"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = require("./style");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Loader = () => ( /*#__PURE__*/_react.default.createElement(_style.LoaderStyled, null, /*#__PURE__*/_react.default.createElement("svg", {
  width: "36",
  height: "40",
  viewBox: "0 0 36 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img"
}, /*#__PURE__*/_react.default.createElement("title", null, "Loading"), /*#__PURE__*/_react.default.createElement(_style.Top, {
  d: "M17.914 0.695986L35.258 9.66199L17.89 18.579L0.707985 9.64801L17.914 0.695986Z",
  fill: "#3D3D3D"
}), /*#__PURE__*/_react.default.createElement(_style.Middle, {
  d: "M0.723011 20.194L6.135 17.512L17.895 23.345L29.782 17.505L35.336 20.205L17.894 28.671L0.723011 20.194Z",
  fill: "#3D3D3D"
}), /*#__PURE__*/_react.default.createElement(_style.Bottom, {
  d: "M0.68401 30.536L6.12902 27.58L17.896 34.015L29.783 27.626L35.283 30.537L17.897 39.842L0.68401 30.536Z",
  fill: "#3D3D3D"
}))));
var _default = exports.default = Loader;